module.exports = __webpack_public_path__ + "img/9.6df84507.jpg";